import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fnsr-sync',
  templateUrl: './sync.component.html'
})
export class SyncComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
